import { ArchiveState } from "@/store/Crud/functions/archived/State";
export class State extends ArchiveState {
  vehicleUsageRequirementsByLicenseClass: Array<any> = [];
  vehiclesByInstructorAndUsageAndLicenseClass: Array<any> = [];
  vehiclesByCurrentInstructor: Array<any> = [];
}
